import { Controller, UseFormReturn } from 'react-hook-form';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useMySpaces } from '@zep/apis';
import { StoreAssetUploadDataType, UploadCommonFormProps } from '../../../../types/StoreTypes';
import ContentSelectionGrid from './ContentSelectionGrid';
import S from './UploadCommonForm.module.scss';

/**
 * 맵/오브젝트 공통 정보 입력 폼
 * @param props
 * @constructor
 */
const UploadCommonMapForm = (props: UploadCommonFormProps) => {
  const {
    isEditBlocked,
    commonForm
  } = props;
  const router = useRouter();
  const {
    t
  } = useTranslation(['store']);
  const editHashId = router.query.edit?.toString() ?? '';
  const {
    control,
    formState: {
      errors
    }
  } = commonForm as UseFormReturn<StoreAssetUploadDataType>;

  // 소유한 스페이스 목록
  const spacesSourceListQuery = useMySpaces();
  return <div className={S.upload_form} data-sentry-component="UploadCommonMapForm" data-sentry-source-file="UploadCommonMapForm.tsx">
      <div className={S.upload_form_row}>
        <label>
          {t('store:store_something_select', {
          x: t('store:store_asset_map')
        })}
        </label>
        <Controller control={control} name="sourceSpaceHashId" render={({
        field: {
          value,
          onChange
        }
      }) => <ContentSelectionGrid contents={spacesSourceListQuery.isSuccess ? spacesSourceListQuery.data.spaces : []} onContentSelect={(spaceId: string) => onChange(spaceId)} selectedContentHashId={value} disabled={!!editHashId || isEditBlocked} aspectRatio="272 / 190" />} data-sentry-element="Controller" data-sentry-source-file="UploadCommonMapForm.tsx" />
        {!!errors.sourceSpaceHashId && <div className={S.error_text}>
            {errors.sourceSpaceHashId?.message}
          </div>}
      </div>
    </div>;
};
export default UploadCommonMapForm;